var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-dialog",
    {
      staticClass: "add-label-dialog",
      attrs: {
        title: "选择群聊",
        visible: _vm.dialogVisibleM,
        "modal-append-to-body": false,
        width: "70%",
        "close-on-click-modal": false
      },
      on: {
        close: _vm.closeDialog,
        "update:visible": function($event) {
          _vm.dialogVisibleM = $event
        }
      }
    },
    [
      _c(
        "div",
        {
          directives: [
            {
              name: "loading",
              rawName: "v-loading",
              value: _vm.loading,
              expression: "loading"
            }
          ],
          staticClass: "dialog-container"
        },
        [
          _c(
            "div",
            { staticClass: "cus-chat-supervise-search" },
            [
              _c(
                "el-form",
                { attrs: { inline: true } },
                [
                  _c(
                    "el-form-item",
                    { staticClass: "el-form-item", attrs: { label: "群名称" } },
                    [
                      _c("el-input", {
                        staticStyle: { width: "120px" },
                        attrs: { size: "mini", clearable: "" },
                        on: { change: _vm.selectBindStatus },
                        model: {
                          value: _vm.formInline.chatName,
                          callback: function($$v) {
                            _vm.$set(_vm.formInline, "chatName", $$v)
                          },
                          expression: "formInline.chatName"
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { staticClass: "el-form-item", attrs: { label: "群主" } },
                    [
                      _c("el-input", {
                        staticStyle: { width: "120px" },
                        attrs: { size: "mini", clearable: "" },
                        on: { change: _vm.selectBindStatus },
                        model: {
                          value: _vm.formInline.ownerName,
                          callback: function($$v) {
                            _vm.$set(_vm.formInline, "ownerName", $$v)
                          },
                          expression: "formInline.ownerName"
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { staticClass: "el-form-item", attrs: { label: "群标签" } },
                    [
                      _c("el-cascader", {
                        staticStyle: { width: "150px" },
                        attrs: {
                          options: _vm.tagList,
                          props: _vm.tagProps,
                          size: "mini",
                          "show-all-levels": false
                        },
                        on: { change: _vm.selectTagItem },
                        model: {
                          value: _vm.searchTagItem,
                          callback: function($$v) {
                            _vm.searchTagItem = $$v
                          },
                          expression: "searchTagItem"
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    {
                      staticClass: "el-form-item",
                      attrs: { label: "建群时间" }
                    },
                    [
                      _c("el-date-picker", {
                        staticStyle: { width: "240px" },
                        attrs: {
                          type: "daterange",
                          "range-separator": "至",
                          "start-placeholder": "开始时间",
                          "end-placeholder": "结束时间",
                          size: "small"
                        },
                        on: { change: _vm.selectBindStatus },
                        model: {
                          value: _vm.date,
                          callback: function($$v) {
                            _vm.date = $$v
                          },
                          expression: "date"
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          ),
          _c(
            "div",
            { ref: "tableWrapper", staticClass: "table-row" },
            [
              _c(
                "el-table",
                {
                  ref: "cusChatTable",
                  attrs: {
                    size: "small",
                    data: _vm.tableData,
                    fit: "",
                    "highlight-current-row": "",
                    align: "center",
                    "header-cell-style": { background: "#eef1f6" },
                    height: _vm.tableHeight
                  },
                  on: { "selection-change": _vm.handleSelectionChange }
                },
                [
                  _c("el-table-column", {
                    attrs: {
                      type: "selection",
                      width: "55",
                      selectable: _vm.checkSelection
                    }
                  }),
                  _c("el-table-column", {
                    attrs: { label: "序号", width: "80" },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function(scope) {
                          return [
                            _vm._v(
                              " " +
                                _vm._s(_vm.getGlobalIndex(scope.$index)) +
                                " "
                            )
                          ]
                        }
                      }
                    ])
                  }),
                  _c("el-table-column", {
                    attrs: {
                      prop: "chatName",
                      label: "群名称",
                      "show-overflow-tooltip": "",
                      align: "center"
                    }
                  }),
                  _c("el-table-column", {
                    attrs: { prop: "ownerName", label: "群主", align: "center" }
                  }),
                  _c("el-table-column", {
                    attrs: {
                      prop: "groupChatTagDetailDtoList",
                      label: "群标签",
                      "min-width": "120",
                      "show-overflow-tooltip": "",
                      align: "center"
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function(scope) {
                          return _vm._l(
                            scope.row.groupChatTagDetailDtoList,
                            function(item) {
                              return _c(
                                "el-tag",
                                {
                                  key: item.tagId,
                                  staticStyle: { margin: "3px" },
                                  attrs: { size: "small" }
                                },
                                [
                                  _c(
                                    "el-popover",
                                    {
                                      attrs: {
                                        placement: "bottom-start",
                                        width: "150",
                                        trigger: "hover"
                                      }
                                    },
                                    [
                                      _c(
                                        "span",
                                        {
                                          attrs: { slot: "reference" },
                                          slot: "reference"
                                        },
                                        [_vm._v(_vm._s(item.tagName))]
                                      ),
                                      _vm._l(
                                        scope.row.groupChatTagDetailDtoList,
                                        function(item) {
                                          return _c(
                                            "el-tag",
                                            {
                                              key: item.tagId,
                                              staticStyle: { margin: "3px" },
                                              attrs: {
                                                size: "small",
                                                closable: ""
                                              },
                                              on: {
                                                close: function($event) {
                                                  return _vm.deleteGroupTag(
                                                    scope.row.chatId,
                                                    item.tagId
                                                  )
                                                }
                                              }
                                            },
                                            [_vm._v(_vm._s(item.tagName))]
                                          )
                                        }
                                      )
                                    ],
                                    2
                                  )
                                ],
                                1
                              )
                            }
                          )
                        }
                      }
                    ])
                  }),
                  _c("el-table-column", {
                    attrs: { prop: "memNum", label: "群人数", align: "center" }
                  }),
                  _c("el-table-column", {
                    attrs: {
                      prop: "memQuitNum",
                      label: "退群人数",
                      align: "center"
                    }
                  }),
                  _c("el-table-column", {
                    attrs: {
                      prop: "dayMemQuitNum",
                      label: "当天进群/退群人数",
                      align: "center"
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function(scope) {
                          return [
                            _c("span", [
                              _vm._v(
                                _vm._s(
                                  scope.row.dayMemJoinNum > 0
                                    ? "+" + scope.row.dayMemJoinNum
                                    : 0
                                ) +
                                  "/" +
                                  _vm._s(
                                    scope.row.dayMemQuitNum > 0
                                      ? "-" + scope.row.dayMemQuitNum
                                      : 0
                                  )
                              )
                            ])
                          ]
                        }
                      }
                    ])
                  }),
                  _c("el-table-column", {
                    attrs: {
                      prop: "createTime",
                      label: "建群时间",
                      align: "center"
                    }
                  })
                ],
                1
              )
            ],
            1
          ),
          _c("Pagination", {
            staticClass: "Pagination-row",
            attrs: { childMsg: _vm.pageparm, pageSizes: _vm.pageSizes },
            on: { callBack: _vm.callBack }
          })
        ],
        1
      ),
      _c(
        "div",
        {
          staticClass: "dialog-footer",
          staticStyle: {
            display: "flex",
            "justify-content": "space-between",
            "align-items": "center"
          },
          attrs: { slot: "footer" },
          slot: "footer"
        },
        [
          _c("span", [
            _vm._v("已选：" + _vm._s(_vm.selectedList.length || 0) + "条")
          ]),
          _c(
            "div",
            [
              _c(
                "el-button",
                {
                  staticStyle: { "margin-right": "20px" },
                  attrs: { size: "small " },
                  on: { click: _vm.closeDialog }
                },
                [_vm._v("取 消")]
              ),
              _c(
                "el-button",
                {
                  attrs: {
                    type: "primary",
                    size: "small",
                    disabled: _vm.loading
                  },
                  on: {
                    click: function($event) {
                      return _vm.confirmWeicome()
                    }
                  }
                },
                [_vm._v("确 定")]
              )
            ],
            1
          )
        ]
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }